import { render, staticRenderFns } from "./VideoRect.vue?vue&type=template&id=187c17fd&scoped=true&lang=pug&"
import script from "./VideoRect.vue?vue&type=script&lang=js&"
export * from "./VideoRect.vue?vue&type=script&lang=js&"
import style0 from "./VideoRect.scss?vue&type=style&index=0&id=187c17fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c17fd",
  null
  
)

export default component.exports